module.exports = __webpack_public_path__ + "img/performance_appraisal_banner2.fa81db88.jpg";